import { render, staticRenderFns } from "./DrillResultMath.vue?vue&type=template&id=0c1fd36a&scoped=true&lang=pug&"
import script from "./DrillResultMath.vue?vue&type=script&lang=ts&"
export * from "./DrillResultMath.vue?vue&type=script&lang=ts&"
import style0 from "./DrillResultMath.vue?vue&type=style&index=0&id=0c1fd36a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1fd36a",
  null
  
)

export default component.exports